<template>
  <div id="app">
    <template v-if="handleLoader">
      <a href="#main-content" class="skip-link">Saltar para o conteúdo principal</a>
      <NavBar :currPathID="currPathID" />

      <main id="main-content">
        <Modal :modalTitle="modalData.title" :showHeader="modalData.showHeader">
          <component :is="modalData.component" :content="setModalContent" />
        </Modal>
        <router-view :style="cssVars" class="appContent" v-if="handleLoader" />
      </main>

      <Footer
        v-show="this.$route.path != '/resumo'"
        :prevRoute="prevRoute"
        :nextRoute="nextRoute"
      />
      <!-- <div class="dLine"></div> -->
    </template>
    <LoadingView v-else />
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import NavBar from "./components/NavBar/NavBar.vue";
import Modal from "./components/Modal/Modal.vue";
import Footer from "./components/Footer/Footer.vue";
import LoadingView from "./views/LoadingView.vue";
import { navigatonFunctions } from "./mixins/navigatonFunctions";
import { cookiesFunc } from "./mixins/cookiesFunc";

// components for modal
import DefaultModalContent from "./components/TemplateParts/ModalContent/DefaultModalContent.vue";
import ConfigCardModalContent from "./components/TemplateParts/ModalContent/ConfigCardModalContent.vue";
import CarGalery from "./components/TemplateParts/SwiperConts/CarGalery.vue";
import FormProposal from "./components/TemplateParts/Forms/FormProposal.vue";
import FormTestDrive from "./components/TemplateParts/Forms/FormTestDrive.vue";
import FormCfgEmail from "./components/TemplateParts/Forms/FormCfgEmail.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Modal,
    Footer,
    LoadingView,
    DefaultModalContent,
    ConfigCardModalContent,
    CarGalery,
    FormProposal,
    FormTestDrive,
    FormCfgEmail,
  },
  mixins: [navigatonFunctions, cookiesFunc],
  created() {
    this.$store.dispatch("fetchModelsLst");
    this.$store.dispatch("dataBO/fetchBOdata");
    this.$store.dispatch("fetchCarrosPods");

    // read, call api, remove cookie
    let ids = this.getCookieValue("wp_dealersOIDs");
    this.$store.dispatch("dealersLst/fetchDealers", ids);
    this.eraseCookie("wp_dealersOIDs");
  },
  computed: {
    ...mapState([
      "modalData",
      "hasCars",
      "resumeData",
      "versionsData",
      "footerHeight",
    ]),
    ...mapGetters({
      setModalContent: "modalData/getModalContent",
      hasEngine: "enginesData/modelHasEngine",
      engHasVersns: "versionsData/hasVersions",
      hasColors: "images360/modelHasColors",
      hasIntColors: "panoram360/modelHasPanoramImgs",
      isPanrmPending: "panoram360/isPanrmPending",
    }),
    cssVars() {
      return {
        "--appContent-margin": this.footerHeight + "px", // n dynamic --> CSS <-- vars
      };
    },
    handleLoader() {
      let path = this.$route.name;
      let modelid = this.resumeData.modelid;

      // let href = window.location.href

      switch (path) {
        case "Configurador":
          if (this.hasCars) return true;
          break;

        case "Motors":
          if (!modelid) {
            this.$router.replace("/");
            return true;
          }
          if (this.hasEngine(modelid) && this.hasColors(modelid)) {
            return true;
          } else {
            this.$store.dispatch("enginesData/fetchEngines", modelid);
          }
          break;

        case "Version":
          if (!modelid) {
            this.$router.replace("/");
            return true;
          }
          if (this.engHasVersns(modelid)) {
            return true;
          } else {
            this.$store.dispatch("versionsData/fetchVersions", modelid);
            this.$store.dispatch("versionsData/fetchEquipments");
          }
          break;

        case "Comparator":
        case "DesignExterior":
          if (!modelid) {
            this.$router.replace("/");
            return true;
          }
          return true;

        case "DesignInterior":
          if (!modelid) {
            this.$router.replace("/");
            return true;
          }

          return !this.isPanrmPending;

        case "Resume":
          if (!modelid) {
            this.$router.replace("/");
            return true;
          }
          return this.handleDisplayResumePage();

        default:
          return false;
      }

      return false;
    },
  },
  methods: {
    handleDisplayResumePage() {
      let resume = this.resumeData;
      let priceCE = resume.configSelected?.dsgExt?.price;
      let priceCI = resume.configSelected?.dsgExt?.price;

      // check if user selected exterior && interior
      if (priceCE || priceCI) {
        if (priceCE == 0 && priceCI == 0) return true;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-decoration: none;
  font-family: $regular;
  font-weight: normal;
  font-style: normal;
}

.isActive,
.swiper-container {
  overflow: hidden;
}

button {
  cursor: pointer;
}

.dLine {
  position: fixed;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #000;
  height: 5px;
  width: 8.375rem;
  z-index: 987;
  border-radius: 5px;
}

.appContent {
  margin-bottom: calc(var(--appContent-margin) + 4rem);

  @import "./scss/main.scss";

  @include respond-to(large) {
    margin-top: unset;
    margin-bottom: calc(var(--appContent-margin) + 7rem);
  }
}

.skip-link {
  position: absolute;
  top: -50px;
  left: 8px;
  color: #fff;
  padding: 1rem 1rem;
  text-decoration: none;
  z-index: 99999;
  font-size: 12px;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-family: $regular;
  font-weight: 400;
  text-transform: uppercase;
  border: none;
  background-color: #002C5F;
  box-shadow: inset 0 0 0 1px #002C5F;


  &:focus {
    top: 20px;
    outline: 0
  }

  &:hover {
    background-color: #006177;
    box-shadow: inset 0 0 0 1px #006177;
    color: #fff;
  }
}
</style>
